import React from 'react'
import classnames from 'classnames'
import { getInputStyles } from '../../../components/Form/styles'

interface ModifiedDescriptionFieldProps {
  value: string
  onChange: (value: string) => void
  error?: string
  className?: string
  label?: string
}

/**
 * Required "change reason" textarea shown on every program-onboarding mutation
 * (maps to `modifiedDescription`, per WEB-7241's audit-trail requirement).
 */
const ModifiedDescriptionField: React.FC<ModifiedDescriptionFieldProps> = ({
  value,
  onChange,
  error,
  className,
  label = 'Change reason',
}) => {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 truncate text-left">
        {label} <span className="ml-1 text-sm text-red-500 dark:text-red-500">*</span>
      </label>
      <textarea
        className={classnames(getInputStyles({ error: error != null }), 'mt-1')}
        rows={2}
        maxLength={500}
        value={value}
        placeholder="Jira ticket reference or free text"
        onChange={(e) => onChange(e.target.value)}
      />
      {error != null && <p className="mt-1 text-xs text-left text-red-600 dark:text-red-500">{error}</p>}
    </div>
  )
}

export default ModifiedDescriptionField
